// iter135 — Floating Action Button. Renders only on mobile, only when a
// `to` (Link) or `onClick` is provided. Sits above the BottomNav with a
// safe-area-aware offset and a soft brand-colored halo.
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";

export default function FAB({ to, onClick, label = "Add", Icon = Plus, testid = "fab-add-entry" }) {
  const cls =
    "fixed right-4 z-30 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-600 text-white shadow-[0_12px_30px_-10px_rgba(37,99,235,0.6)] ring-4 ring-brand-100 transition-transform active:scale-95 md:hidden";
  // Sit 80px above bottom (BottomNav is ~56px tall + safe area).
  const style = { bottom: "calc(72px + env(safe-area-inset-bottom, 0px))" };
  if (to) {
    return (
      <Link to={to} data-testid={testid} aria-label={label} className={cls} style={style}>
        <Icon className="h-6 w-6" strokeWidth={2.5} />
      </Link>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      aria-label={label}
      className={cls}
      style={style}
    >
      <Icon className="h-6 w-6" strokeWidth={2.5} />
    </button>
  );
}
